import React, { useEffect, useState } from "react";
import { datalayerPush } from "../../GTM";

interface SearchProps {
    searchPageUrl: string;
}

const Search: React.FC<SearchProps> = ({ searchPageUrl }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState("");
    const searchIconRef = React.useRef<HTMLButtonElement>(null);
    const searchInputRef = React.useRef<HTMLInputElement>(null);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // TODO GTM: add gtm event here?
        if (e.key === "Enter") {
            window.location.href = `${searchPageUrl}?q=${query}`;
        }
    };

    const closeMenu = () => {
        datalayerPush("close_search");
        setIsOpen(false);
        searchIconRef.current?.focus();
    };

    const toggleMenu = () => {
        if (!isOpen) {
            datalayerPush("open_search");
            setIsOpen(true);
        } else {
            closeMenu();
        }
    };

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef?.current?.focus();
        }
    }, [isOpen]);

    return (
        <>
            <button
                aria-expanded={isOpen}
                aria-label={isOpen ? "Dölj sökfältet" : "Visa sökfältet"}
                className={`search-link accordion-trigger ${isOpen ? "hide-on-xs" : ""}`}
                onClick={toggleMenu}
                title={isOpen ? "Dölj sökfältet" : "Visa sökfältet"}
                ref={searchIconRef}
            >
                <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            <button
                aria-label="Dölj sökfältet"
                className={`top-close-button`}
                onClick={closeMenu}
                title="Dölj sökfältet"
            >
                <img
                    alt=""
                    height="18"
                    src="/static/images/garant/cross/cross-green-thin.svg"
                    width="19"
                />
            </button>
            {isOpen && (
                <div className="search-wrapper">
                    <div>
                        <a
                            aria-label="Sök (navigerar till sökresultat-sidan)"
                            className="search-icon"
                            // TODO GTM add data-gtm here?
                            href={`${searchPageUrl}?q=${query}`}
                            title="Sök (navigerar till sökresultat-sidan)"
                        >
                            <i className="fa-solid fa-magnifying-glass"></i>
                        </a>
                        <input
                            aria-label="Vad letar du efter? Tryck Enter för att söka"
                            placeholder="Vad letar du efter?"
                            autoComplete="off"
                            onChange={(e) => setQuery(e.target.value)}
                            onKeyDown={handleKeyDown}
                            ref={searchInputRef}
                            value={query}
                        />
                    </div>
                    <button
                        aria-label="Dölj sökfältet"
                        className="close accordion-trigger hide-on-xs"
                        onClick={closeMenu}
                        title="Dölj sökfältet"
                    >
                        <img
                            alt=""
                            height="18"
                            src="/static/images/garant/cross/cross-green-thin.svg"
                            width="19"
                        />
                    </button>
                </div>
            )}
        </>
    );
};

export default Search;
